import React from "react";
import "./TemplateRenderer.css";


export default function TemplateRenderer({ content }) {
  if (!content?.root?.children) return null;


  const renderNode = (node, index) => {
    switch (node.type) {
      case "heading": {
        const text = node.children?.map((c) => c.text).join("");
        const Tag = node.tag || "h1";
        return <Tag key={index}>{text}</Tag>;
      }


      case "paragraph": {
        const text = node.children?.map((c) => c.text).join("");
        return (
          <p key={index} className="paragraph">
            {text}
          </p>
        );
      }


      case "table":
        return (
          <table key={index} className="template-table">
            <tbody>
              {node.children?.map((row, i) => (
                <tr key={i}>
                  {row.children?.map((cell, j) => {
                    const cellText = cell.children?.[0]?.children
                      ?.map((c) => c.text)
                      .join("");


                    const CellTag =
                      cell.headerState > 0 ? "th" : "td";


                    return <CellTag key={j}>{cellText}</CellTag>;
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        );


      case "list":
        const ListTag =
          node.listType === "number" ? "ol" : "ul";


        return (
          <ListTag key={index}>
            {node.children?.map((item, i) => {
              const itemText = item.children?.[0]?.children
                ?.map((c) => c.text)
                .join("");


              return <li key={i}>{itemText}</li>;
            })}
          </ListTag>
        );


      case "panel":
        return (
          <div key={index} className={`panel panel-info`}>
            {node.children?.map((child, i) =>
              renderNode(child, i)
            )}
          </div>
        );


      default:
        return null;
    }
  };


  return (
    <div className="template-renderer">
      {content.root.children.map((node, index) =>
        renderNode(node, index)
      )}
    </div>
  );
}
